module.exports = __webpack_public_path__ + "img/product32_scenario.88eb129f.png";